import { useState } from "react";
import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Package, Building2, ArrowRightLeft, Wrench } from "lucide-react";
import MainInventoryView from "@/components/inventory/MainInventoryView";
import BranchInventoryView from "@/components/inventory/BranchInventoryView";
import InventoryTransfersView from "@/components/inventory/InventoryTransfersView";
import SparePartTypesView from "@/components/inventory/SparePartTypesView";
import { useAuth } from "@/context/AuthContext";

const Inventory = () => {
  const { profile } = useAuth();
  const isSuperAdmin = profile?.role === 'super_admin';

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Package className="h-6 w-6 text-bike-600" />
          <h1 className="text-2xl font-bold text-gray-800">
            Inventario de Repuestos
          </h1>
        </div>

        <Tabs defaultValue={isSuperAdmin ? "main" : "branch"} className="space-y-6">
          <TabsList className="grid w-full grid-cols-4">
            {isSuperAdmin && (
              <TabsTrigger value="main" className="flex items-center gap-2">
                <Package className="h-4 w-4" />
                Principal
              </TabsTrigger>
            )}
            <TabsTrigger value="branch" className="flex items-center gap-2">
              <Building2 className="h-4 w-4" />
              Sucursal
            </TabsTrigger>
            <TabsTrigger value="transfers" className="flex items-center gap-2">
              <ArrowRightLeft className="h-4 w-4" />
              Transferencias
            </TabsTrigger>
            <TabsTrigger value="types" className="flex items-center gap-2">
              <Wrench className="h-4 w-4" />
              Tipos
            </TabsTrigger>
          </TabsList>

          {isSuperAdmin && (
            <TabsContent value="main">
              <Card>
                <CardHeader>
                  <CardTitle>Inventario Principal</CardTitle>
                </CardHeader>
                <CardContent>
                  <MainInventoryView />
                </CardContent>
              </Card>
            </TabsContent>
          )}

          <TabsContent value="branch">
            <Card>
              <CardHeader>
                <CardTitle>Inventario de Sucursal</CardTitle>
              </CardHeader>
              <CardContent>
                <BranchInventoryView />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="transfers">
            <Card>
              <CardHeader>
                <CardTitle>Transferencias de Inventario</CardTitle>
              </CardHeader>
              <CardContent>
                <InventoryTransfersView />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="types">
            <Card>
              <CardHeader>
                <CardTitle>Tipos de Repuestos</CardTitle>
              </CardHeader>
              <CardContent>
                <SparePartTypesView />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
};

export default Inventory;
